import { useEffect, useState } from 'react';

const SESSION_KEY = 'geo_country';
const WAITING_LIST_URL = 'https://obsessless.com/waitlist';

const BLOCKED_COUNTRIES: ReadonlySet<string> = new Set([
  'GB', // United Kingdom
]);

type GeoRedirectState = {
  isCheckingGeo: boolean;
  isRedirecting: boolean;
};

const getCountryFromApi = async (): Promise<string | null> => {
  try {
    const response = await fetch('https://ipapi.co/country/', {
      signal: AbortSignal.timeout(3000),
    });

    if (!response.ok) {
      return null;
    }

    const country = (await response.text()).trim().toUpperCase();
    return country;
  } catch {
    return null;
  }
};

export const useGeoRedirect = (): GeoRedirectState => {
  const [state, setState] = useState<GeoRedirectState>(() => {
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) {
      const isBlocked = BLOCKED_COUNTRIES.has(cached);
      return { isCheckingGeo: false, isRedirecting: isBlocked };
    }
    return { isCheckingGeo: true, isRedirecting: false };
  });

  useEffect(() => {
    const cached = sessionStorage.getItem(SESSION_KEY);

    if (cached) {
      if (BLOCKED_COUNTRIES.has(cached)) {
        window.location.href = WAITING_LIST_URL;
      }
      return;
    }

    let cancelled = false;

    const checkGeo = async () => {
      const country = await getCountryFromApi();

      if (cancelled) return;

      if (country) {
        sessionStorage.setItem(SESSION_KEY, country);
      }

      if (country && BLOCKED_COUNTRIES.has(country)) {
        setState({ isCheckingGeo: false, isRedirecting: true });
        window.location.href = WAITING_LIST_URL;
      } else {
        setState({ isCheckingGeo: false, isRedirecting: false });
      }
    };

    checkGeo();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
